import styled, { css } from 'styled-components';
import { themeBorder, themeColor } from '../../../theme/getters';
import { media } from '../../../theme/media';
import {
  nonResponsiveH3,
  nonResponsiveSpacedHeading,
  nonResponsiveSmallSpacedHeading,
  winnowHeading,
} from '../../../theme/typography';

const areasWithImage = css`
  grid-template-areas: 'image' 'title' 'code' 'total';
  ${media.tablet`
    grid-template-areas: 'image title' 'image code' 'image total';
  `};
`;

const areasWithoutImage = css`
  grid-template-areas: 'title' 'code' 'total';
  ${media.tablet`
    grid-template-areas: 'title title' 'code code' 'total total';
  `};
`;

export const Container = styled.div`
  border: ${themeBorder('regular')};
  display: grid;
  grid-template-columns: 1fr;
  background-color: ${themeColor('white')};

  ${media.tablet`
    grid-template-columns: 250px;
  `};

  ${props => (props.noImage ? areasWithoutImage : areasWithImage)};
`;

export const ImageWrapper = styled.div`
  display: flex;
  grid-area: image;
  border-right: ${themeBorder('regular')};
`;

export const Image = styled.img`
  height: 100%;
  width: 100%;
  object-fit: cover;
`;

export const TitleWrapper = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: center;
  flex-direction: column;
  grid-area: title;
  padding: 24px;
  ${media.tablet`
    padding-left: 32px;
    padding-right: 32px;
  `};
`;

export const Title = styled(nonResponsiveH3)`
  text-align: left;
`;

export const DateTimeWrapper = styled.div`
  ${nonResponsiveSmallSpacedHeading};
  margin-top: 16px;
  display: grid;
  grid-column-gap: 16px;
  grid-template-columns: 1fr 1fr;

  ${media.tablet`
    grid-template-columns: auto auto 1fr;
  `}
`;

export const DateTimeItem = styled.div`
  display: flex;
  margin-top: 8px;

  &:first-of-type {
    margin-top: 0px;
  }
`;

export const DateTimeText = styled.p`
  margin: 0 0 0 8px;
  text-align: left;
`;

export const ContentWrapper = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: center;
  flex-direction: column;
  grid-area: code;
  border-top: ${themeBorder('regular')};
  border-bottom: ${themeBorder('regular')};
  text-align: left;
  padding: 24px;
  ${media.tablet`
    padding-left: 32px;
    padding-right: 32px;
  `};
`;

export const TotalWrapper = styled.div`
  grid-area: total;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 24px;
  ${media.tablet`
    padding-left: 32px;
    padding-right: 32px;
  `};
`;

export const TotalTitle = styled.h1`
  ${nonResponsiveSpacedHeading}
`;

export const TotalAmount = styled.p`
  ${winnowHeading}
`;
